import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthGuard, AuthRedirectService, AuthService, OCC_USER_ID_CURRENT, SemanticPathService } from '@spartacus/core';
import { map } from 'rxjs/operators';
import { isPlatformServer } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CustomAuthGuard extends AuthGuard {
  constructor(
    protected authService: AuthService,
    protected authRedirectService: AuthRedirectService,
    protected router: Router,
    protected semanticPathService: SemanticPathService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    super(authService, authRedirectService, router, semanticPathService);
  }

  canActivate(): Observable<boolean | UrlTree> {
    if (isPlatformServer(this.platformId)) {
      return of(true);
    }
    const auth = JSON.parse(localStorage.getItem('spartacus⚿⚿auth'));
    if (!!auth && auth['userId'] === OCC_USER_ID_CURRENT) {
      return of(true);
    }
    return this.authService.isUserLoggedIn().pipe(
      map((isLoggedIn) => {
        if (!isLoggedIn) {
          this.authRedirectService.saveCurrentNavigationUrl();
          return this.router.parseUrl('/?login=true');
        }
        return isLoggedIn;
      })
    );
  }
}
